import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Div } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

const BottomContent: FunctionComponent = () => {
  const history = useHistory();
  const { t } = useTranslation('onboarding');
  return (
    <Div>
      <Button margin={{ top: 'lg' }} variant={'primary'} onClick={() => history.push('/onboarding/usergroups')} size="xl">
        {t('getStarted.startButton')}
      </Button>
    </Div>
  );
};

export default BottomContent;
